import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PopupService {
  private openPopups: Set<string> = new Set<string>();

  isPopupOpen(popupId: string): boolean {
    console.log(this.openPopups);

    return this.openPopups.has(popupId);
  }

  addPopup(popupId: string) {
    this.openPopups.add(popupId);
  }

  removePopup(popupId: string) {
    this.openPopups.delete(popupId);
  }
}
